import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createBlock as _createBlock, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, vModelSelect as _vModelSelect, withDirectives as _withDirectives, withModifiers as _withModifiers, vModelText as _vModelText, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-66f0b170"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "flex flex-lg-row flex-column result-buttons column-row-gap-10"
}
const _hoisted_2 = { class: "result-buttons__button-group flex" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  "aria-hidden": "true",
  class: "icon-svg",
  focusable: "false"
}, [
  /*#__PURE__*/_createElementVNode("use", { "xlink:href": "#file-download" })
], -1))
const _hoisted_4 = { class: "result-buttons__button-group" }
const _hoisted_5 = {
  id: "comparison-download-pdf-button",
  class: "button button-secondary flex-grow-equally",
  "aria-label": "Download comparison as PDF",
  onclick: "window.print()"
}
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  "aria-hidden": "true",
  class: "icon-svg",
  focusable: "false"
}, [
  /*#__PURE__*/_createElementVNode("use", { "xlink:href": "#file-download" })
], -1))
const _hoisted_7 = { class: "container px-0" }
const _hoisted_8 = {
  key: 0,
  id: "test"
}
const _hoisted_9 = { class: "container px-0 py-9" }
const _hoisted_10 = {
  key: 0,
  "aria-atomic": "true",
  class: "alert alert-info",
  role: "alert",
  style: {"max-width":"100%","display":"flex"},
  id: "info-box-declaration-wrapper-div"
}
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { style: {"flex":"0 0 3%"} }, [
  /*#__PURE__*/_createElementVNode("svg", {
    "aria-hidden": "true",
    class: "info-icon-size",
    focusable: "false"
  }, [
    /*#__PURE__*/_createElementVNode("use", { "xlink:href": "#info" })
  ])
], -1))
const _hoisted_12 = { style: {"flex":"1"} }
const _hoisted_13 = {
  key: 1,
  class: "py-4",
  id: "comparison-table-overview-section"
}
const _hoisted_14 = { class: "py-4 my-4" }
const _hoisted_15 = { class: "tableContainer" }
const _hoisted_16 = {
  class: "table w-percent-100",
  id: "comparison-overview-table"
}
const _hoisted_17 = {
  class: "text-primary",
  scope: "row",
  style: {"width":"20%"}
}
const _hoisted_18 = ["data-cy-name"]
const _hoisted_19 = {
  class: "text-primary",
  scope: "row",
  style: {"width":"20%"}
}
const _hoisted_20 = ["data-cy-name"]
const _hoisted_21 = {
  class: "text-primary",
  scope: "row",
  style: {"width":"20%"}
}
const _hoisted_22 = ["data-cy-name"]
const _hoisted_23 = {
  class: "text-primary",
  scope: "row",
  style: {"width":"20%"}
}
const _hoisted_24 = ["data-cy-name"]
const _hoisted_25 = ["data-cy-name"]
const _hoisted_26 = {
  class: "text-primary",
  scope: "row",
  style: {"width":"20%"}
}
const _hoisted_27 = ["data-cy-name"]
const _hoisted_28 = {
  class: "text-primary",
  scope: "row",
  style: {"width":"20%"}
}
const _hoisted_29 = ["data-cy-name"]
const _hoisted_30 = { class: "container px-0 py-0" }
const _hoisted_31 = {
  key: 0,
  "aria-atomic": "true",
  class: "alert alert-warning",
  role: "alert",
  style: {"max-width":"100%","display":"flex","align-items":"flex-start"},
  id: "warning-box-declaration-wrapper-div"
}
const _hoisted_32 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  style: {"flex":"0 0 3%"},
  class: "pt-4"
}, [
  /*#__PURE__*/_createElementVNode("svg", {
    "aria-hidden": "true",
    class: "icon-svg-warning",
    focusable: "false"
  }, [
    /*#__PURE__*/_createElementVNode("use", { "xlink:href": "#warning" })
  ])
], -1))
const _hoisted_33 = { style: {"flex":"1"} }
const _hoisted_34 = {
  class: "container mb-405",
  "data-cy-id": "graph-section-description"
}
const _hoisted_35 = { class: "py-4 my-4" }
const _hoisted_36 = {
  class: "container px-0 pt-2",
  "data-cy-id": "monetary-difference-text"
}
const _hoisted_37 = {
  "aria-atomic": "true",
  class: "alert alert-info",
  role: "alert",
  style: {"max-width":"100%","display":"flex"},
  id: "info-box-declaration-wrapper-div"
}
const _hoisted_38 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { style: {"flex":"0 0 3%"} }, [
  /*#__PURE__*/_createElementVNode("svg", {
    "aria-hidden": "true",
    class: "info-icon-size",
    focusable: "false"
  }, [
    /*#__PURE__*/_createElementVNode("use", { "xlink:href": "#info" })
  ])
], -1))
const _hoisted_39 = { style: {"flex":"1"} }
const _hoisted_40 = {
  class: "container px-0",
  "data-cy-id": "graph-section"
}
const _hoisted_41 = { class: "py-3" }
const _hoisted_42 = { class: "py-4 row form-group" }
const _hoisted_43 = { class: "col-md-3 form-group" }
const _hoisted_44 = {
  class: "form-label",
  for: "input-comparison-main-filter-criteria"
}
const _hoisted_45 = {
  disabled: "",
  value: ""
}
const _hoisted_46 = {
  key: 1,
  value: 'SCOPES'
}
const _hoisted_47 = {
  key: 2,
  value: 'CATEGORIES'
}
const _hoisted_48 = {
  key: 3,
  value: 'ENERGY'
}
const _hoisted_49 = {
  key: 4,
  value: 'PROCUREMENT'
}
const _hoisted_50 = {
  key: 5,
  value: 'TRANSPORT'
}
const _hoisted_51 = {
  key: 6,
  value: 'TRASH'
}
const _hoisted_52 = {
  key: 7,
  value: 'PRODUCTS'
}
const _hoisted_53 = { class: "col-md-3 form-group" }
const _hoisted_54 = { class: "col-md-4 form-group" }
const _hoisted_55 = ["disabled"]
const _hoisted_56 = { key: 0 }
const _hoisted_57 = { class: "py-4 my-4" }
const _hoisted_58 = { key: 1 }
const _hoisted_59 = { class: "py-4 my-4" }
const _hoisted_60 = { key: 2 }
const _hoisted_61 = { class: "py-4 my-4" }
const _hoisted_62 = {
  class: "py-4",
  id: "comparison-table-graph-section"
}
const _hoisted_63 = {
  key: 0,
  class: "py-4 my-4"
}
const _hoisted_64 = {
  key: 1,
  class: "py-4 my-4"
}
const _hoisted_65 = {
  key: 2,
  class: "py-4 my-4"
}
const _hoisted_66 = {
  key: 3,
  class: "tableContainer"
}
const _hoisted_67 = { class: "table w-percent-100" }
const _hoisted_68 = {
  class: "text-primary",
  scope: "row",
  style: {"width":"20%"}
}
const _hoisted_69 = ["data-cy-name"]
const _hoisted_70 = { key: 0 }
const _hoisted_71 = {
  class: "text-primary",
  scope: "row",
  style: {"width":"20%"}
}
const _hoisted_72 = ["data-cy-name"]
const _hoisted_73 = { key: 1 }
const _hoisted_74 = {
  class: "text-primary",
  scope: "row",
  style: {"width":"20%"}
}
const _hoisted_75 = ["data-cy-name"]
const _hoisted_76 = { key: 2 }
const _hoisted_77 = {
  class: "text-primary",
  scope: "row",
  style: {"width":"20%"}
}
const _hoisted_78 = ["data-cy-name"]
const _hoisted_79 = { key: 3 }
const _hoisted_80 = {
  class: "text-primary",
  scope: "row",
  style: {"width":"20%"}
}
const _hoisted_81 = ["data-cy-name"]
const _hoisted_82 = { key: 4 }
const _hoisted_83 = {
  class: "text-primary",
  scope: "row",
  style: {"width":"20%"}
}
const _hoisted_84 = ["data-cy-name"]
const _hoisted_85 = { key: 5 }
const _hoisted_86 = {
  class: "text-primary",
  scope: "row",
  style: {"width":"20%"}
}
const _hoisted_87 = ["data-cy-name"]
const _hoisted_88 = { key: 6 }
const _hoisted_89 = {
  class: "text-primary",
  scope: "row",
  style: {"width":"20%"}
}
const _hoisted_90 = ["data-cy-name"]
const _hoisted_91 = { key: 7 }
const _hoisted_92 = {
  class: "text-primary",
  scope: "row",
  style: {"width":"20%"}
}
const _hoisted_93 = ["data-cy-name"]
const _hoisted_94 = {
  class: "text-primary",
  scope: "row",
  style: {"width":"20%"}
}
const _hoisted_95 = ["data-cy-name"]
const _hoisted_96 = { class: "bg-green" }
const _hoisted_97 = {
  class: "text-primary",
  scope: "row",
  style: {"width":"20%"}
}
const _hoisted_98 = ["data-cy-name"]
const _hoisted_99 = { key: 9 }
const _hoisted_100 = {
  class: "text-primary",
  scope: "row",
  style: {"width":"20%"}
}
const _hoisted_101 = ["data-cy-name"]
const _hoisted_102 = { class: "container my-5" }
const _hoisted_103 = {
  class: "form-label",
  id: "comparison-comment-field-label",
  for: "input-comparison-main-filter-criteria"
}
const _hoisted_104 = {
  id: "submitButton",
  class: "button button-secondary mt-5",
  type: "submit"
}
const _hoisted_105 = { href: "/klimakompasset/comparison/comparison-overview" }
const _hoisted_106 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  class: "icon-svg",
  focusable: "false",
  "aria-hidden": "true"
}, [
  /*#__PURE__*/_createElementVNode("use", { "xlink:href": "#arrow-left" })
], -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_SimpleText = _resolveComponent("SimpleText")!
  const _component_RichText = _resolveComponent("RichText")!
  const _component_Tooltip = _resolveComponent("Tooltip")!
  const _component_SharedHeader = _resolveComponent("SharedHeader")!
  const _component_ComparisonCalculationMultiSelect = _resolveComponent("ComparisonCalculationMultiSelect")!
  const _component_simple_text = _resolveComponent("simple-text")!
  const _component_ComparisonFilterMultiselect = _resolveComponent("ComparisonFilterMultiselect")!
  const _component_ComparisonChartScope = _resolveComponent("ComparisonChartScope")!
  const _component_ComparisonChartMainCategory = _resolveComponent("ComparisonChartMainCategory")!
  const _component_ComparisonChartIndividualGroups = _resolveComponent("ComparisonChartIndividualGroups")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_SharedHeader, { "data-cy-id": "shared-header" }, {
      firstColumn: _withCtx(() => [
        _createElementVNode("h1", null, [
          _createVNode(_component_SimpleText, { "text-key": "comparison.create-comparison.title" })
        ]),
        _createElementVNode("span", null, [
          _createVNode(_component_RichText, { "text-key": "comparison.create-comparison.header-description" })
        ])
      ]),
      secondColumn: _withCtx(() => [
        false
          ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
              _createElementVNode("div", _hoisted_2, [
                _createElementVNode("a", {
                  id: "comparison-download-excel-link",
                  href: "javascript:void(0)",
                  class: "button button-secondary",
                  onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.exportComparisonToExcel && _ctx.exportComparisonToExcel(...args))),
                  "data-cy-id": 'klimakompasset-resultat-sammenligninger'
                }, [
                  _hoisted_3,
                  _createVNode(_component_SimpleText, { "text-key": "comparison.excel.button.download-title" })
                ]),
                _createVNode(_component_Tooltip, {
                  style: `vertical-align: middle;`,
                  textKey: 'comparison.download-excel-tooltip',
                  size: "lg"
                }, null, 8, ["textKey"])
              ]),
              _createElementVNode("div", _hoisted_4, [
                _createElementVNode("button", _hoisted_5, [
                  _hoisted_6,
                  _createVNode(_component_SimpleText, { "text-key": "comparison.pdf.button.download-title" })
                ])
              ])
            ]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }),
    _createElementVNode("div", _hoisted_7, [
      (!_ctx.isFinishedLoading || !_ctx.comparison)
        ? (_openBlock(), _createBlock(_component_ComparisonCalculationMultiSelect, {
            key: 0,
            onComparisonSelectedCalculations: _ctx.updateComparisonCalcList,
            onFinishedLoadingComparison: _ctx.handleComparisonLoaded,
            mode: _ctx.mode,
            ref: "comparison-multiselect",
            "calculations-to-compare": _ctx.possibleCalculations,
            "comparison-name": _ctx.comparison.comparisonMetadata?.name,
            aria: {'aria-labelledby':'multiselect-comparison-choose-calculation-label', 'aria-placeholder': null, 'aria-multiselectable': null}
          }, null, 8, ["onComparisonSelectedCalculations", "onFinishedLoadingComparison", "mode", "calculations-to-compare", "comparison-name"]))
        : _createCommentVNode("", true)
    ]),
    (_ctx.isFinishedLoading)
      ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
          _createElementVNode("div", _hoisted_9, [
            (_ctx.monetaryDifference())
              ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                  _hoisted_11,
                  _createElementVNode("div", _hoisted_12, [
                    _createElementVNode("p", null, [
                      _createElementVNode("strong", null, [
                        _createVNode(_component_SimpleText, { textKey: "comparison.create.monetary-difference.info.title" })
                      ])
                    ]),
                    _createElementVNode("span", null, [
                      _createVNode(_component_SimpleText, { textKey: "comparison.create.monetary-difference.info.message" })
                    ])
                  ])
                ]))
              : _createCommentVNode("", true),
            (_ctx.comparison.calculations)
              ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
                  _createElementVNode("h3", _hoisted_14, [
                    _createVNode(_component_SimpleText, { "text-key": 'comparison.create.main.title' }, null, 8, ["text-key"])
                  ]),
                  _createElementVNode("div", _hoisted_15, [
                    _createElementVNode("table", _hoisted_16, [
                      _createElementVNode("tbody", null, [
                        _createElementVNode("tr", null, [
                          _createElementVNode("th", _hoisted_17, [
                            _createVNode(_component_SimpleText, { "text-key": "calculation.masterdata.tab.title" })
                          ]),
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.comparison.calculations, (item) => {
                            return (_openBlock(), _createElementBlock("th", {
                              key: item.calculation?.id,
                              "data-cy-name": item.calculation?.calculationPurpose.name,
                              class: "text-dark dynamic-width",
                              scope: "col"
                            }, _toDisplayString(item.calculation?.calculationPurpose.name), 9, _hoisted_18))
                          }), 128))
                        ]),
                        _createElementVNode("tr", null, [
                          _createElementVNode("th", _hoisted_19, [
                            _createVNode(_component_SimpleText, { "text-key": "sharedContent.country" })
                          ]),
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.comparison.calculations, (item) => {
                            return (_openBlock(), _createElementBlock("td", {
                              key: item.calculation?.id,
                              "data-cy-name": item.calculation?.calculationPurpose.name,
                              class: "text-dark dynamic-width"
                            }, _toDisplayString(item.calculation?.companyInformation?.country), 9, _hoisted_20))
                          }), 128))
                        ]),
                        _createElementVNode("tr", null, [
                          _createElementVNode("th", _hoisted_21, [
                            _createVNode(_component_SimpleText, { "text-key": "sharedContent.cvr" })
                          ]),
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.comparison.calculations, (item) => {
                            return (_openBlock(), _createElementBlock("td", {
                              key: item.calculation?.id,
                              "data-cy-name": item.calculation?.calculationPurpose.name,
                              class: "text-dark dynamic-width"
                            }, [
                              (item.calculation?.companyInformation.vatNo)
                                ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                    _createTextVNode(_toDisplayString(item.calculation.companyInformation.vatNo), 1)
                                  ], 64))
                                : (_openBlock(), _createBlock(_component_simple_text, {
                                    key: 1,
                                    "text-key": "comparison.create.no-cvr-registered.message"
                                  }))
                            ], 8, _hoisted_22))
                          }), 128))
                        ]),
                        _createElementVNode("tr", null, [
                          _createElementVNode("th", _hoisted_23, [
                            _createVNode(_component_SimpleText, { "text-key": "sharedContent.location" })
                          ]),
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.comparison.calculations, (item) => {
                            return (_openBlock(), _createElementBlock("td", {
                              key: item.calculation?.id,
                              "data-cy-name": item.calculation?.calculationPurpose.name,
                              class: "text-dark dynamic-width"
                            }, [
                              (item.calculation?.companyInformation?.productionUnits && item.calculation.companyInformation.productionUnits.length)
                                ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(item.calculation.companyInformation.productionUnits, (location) => {
                                    return (_openBlock(), _createElementBlock("p", {
                                      key: location.id,
                                      "data-cy-name": location.pNumber
                                    }, _toDisplayString(_ctx.formatAddressDK(location.address)) + " " + _toDisplayString(location.address.street), 9, _hoisted_25))
                                  }), 128))
                                : (_openBlock(), _createBlock(_component_simple_text, {
                                    key: 1,
                                    "text-key": "comparison.create.no-locations-registered.message"
                                  }))
                            ], 8, _hoisted_24))
                          }), 128))
                        ]),
                        _createElementVNode("tr", null, [
                          _createElementVNode("th", _hoisted_26, [
                            _createVNode(_component_SimpleText, { "text-key": "sharedContent.timeperiod" })
                          ]),
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.comparison.calculations, (item) => {
                            return (_openBlock(), _createElementBlock("td", {
                              key: item.calculation?.id,
                              "data-cy-name": item.calculation?.calculationPurpose.name,
                              class: "text-dark dynamic-width"
                            }, _toDisplayString(_ctx.formatDatesPlain(item.calculation?.calculationPurpose.startDate + '', item.calculation?.calculationPurpose.endDate + '')), 9, _hoisted_27))
                          }), 128))
                        ]),
                        _createElementVNode("tr", null, [
                          _createElementVNode("th", _hoisted_28, [
                            _createVNode(_component_SimpleText, { "text-key": "sharedContent.emf-from" })
                          ]),
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.comparison.calculations, (item) => {
                            return (_openBlock(), _createElementBlock("td", {
                              key: item.calculation?.id,
                              "data-cy-name": item.calculation?.calculationPurpose.name,
                              class: "text-dark dynamic-width"
                            }, _toDisplayString(item.calculation?.emissionCoefficientsVersion?.year), 9, _hoisted_29))
                          }), 128))
                        ])
                      ])
                    ])
                  ])
                ]))
              : _createCommentVNode("", true),
            _createElementVNode("div", _hoisted_30, [
              (_ctx.timePeriodDifference())
                ? (_openBlock(), _createElementBlock("div", _hoisted_31, [
                    _hoisted_32,
                    _createElementVNode("div", _hoisted_33, [
                      _createElementVNode("p", null, [
                        _createElementVNode("strong", null, [
                          _createVNode(_component_SimpleText, { textKey: "comparison.create.time-period-difference.warning.title" })
                        ])
                      ]),
                      _createElementVNode("span", null, _toDisplayString(_ctx.timePeriodDifferenceText()), 1)
                    ])
                  ]))
                : _createCommentVNode("", true)
            ]),
            _createElementVNode("div", _hoisted_34, [
              _createElementVNode("h3", _hoisted_35, [
                _createVNode(_component_SimpleText, { "text-key": 'comparison.create.graph-section.title' }, null, 8, ["text-key"])
              ]),
              _createElementVNode("span", null, [
                _createVNode(_component_SimpleText, { textKey: "comparison.create.graph-section.message" })
              ])
            ]),
            _createElementVNode("div", _hoisted_36, [
              _createElementVNode("div", _hoisted_37, [
                _hoisted_38,
                _createElementVNode("div", _hoisted_39, [
                  _createElementVNode("p", null, [
                    _createElementVNode("strong", null, [
                      _createVNode(_component_SimpleText, { textKey: "comparison.create.scopes-info-banner.title" })
                    ])
                  ]),
                  _createElementVNode("span", null, [
                    _createVNode(_component_SimpleText, { textKey: "comparison.create.scopes-info-banner.message" })
                  ])
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_40, [
              _createElementVNode("div", _hoisted_41, [
                _createElementVNode("form", {
                  onChange: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.formValidation.clearValidField && _ctx.formValidation.clearValidField(...args))),
                  onSubmit: _cache[4] || (_cache[4] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.submitForm && _ctx.submitForm(...args)), ["prevent"])),
                  onInvalidCapture: _cache[5] || (_cache[5] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.formValidation.handleFormValidity && _ctx.formValidation.handleFormValidity(...args)), ["prevent"])),
                  ref: "formGroup"
                }, [
                  _createElementVNode("div", _hoisted_42, [
                    _createElementVNode("div", _hoisted_43, [
                      _createElementVNode("label", _hoisted_44, [
                        _createVNode(_component_SimpleText, { "text-key": "comparison.create.primary-filter.title" })
                      ]),
                      _withDirectives(_createElementVNode("select", {
                        class: "form-select",
                        name: "options",
                        id: "input-comparison-main-filter-criteria",
                        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.selectedComparisonCriteriaDropDown) = $event))
                      }, [
                        _createElementVNode("option", _hoisted_45, [
                          _createVNode(_component_SimpleText, { "text-key": "generic.input.dropdown.option-select.name" })
                        ]),
                        (_openBlock(), _createElementBlock("option", _hoisted_46, [
                          _createVNode(_component_SimpleText, { "text-key": "sharedContent.scopes" })
                        ])),
                        (_openBlock(), _createElementBlock("option", _hoisted_47, [
                          _createVNode(_component_SimpleText, { "text-key": "sharedContent.main-categories" })
                        ])),
                        (_openBlock(), _createElementBlock("option", _hoisted_48, [
                          _createVNode(_component_SimpleText, { "text-key": "calculator.grouping.energy" })
                        ])),
                        (_openBlock(), _createElementBlock("option", _hoisted_49, [
                          _createVNode(_component_SimpleText, { "text-key": "calculator.grouping.purchases" })
                        ])),
                        (_openBlock(), _createElementBlock("option", _hoisted_50, [
                          _createVNode(_component_SimpleText, { "text-key": "calculator.grouping.transport" })
                        ])),
                        (_openBlock(), _createElementBlock("option", _hoisted_51, [
                          _createVNode(_component_SimpleText, { "text-key": "calculator.grouping.garbage" })
                        ])),
                        (_openBlock(), _createElementBlock("option", _hoisted_52, [
                          _createVNode(_component_SimpleText, { "text-key": "calculator.grouping.products" })
                        ]))
                      ], 512), [
                        [_vModelSelect, _ctx.selectedComparisonCriteriaDropDown]
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_53, [
                      _createVNode(_component_ComparisonFilterMultiselect, {
                        "initial-dropdown-choice": _ctx.selectedComparisonScopeCriterias,
                        onComparisonSelectedScopes: _ctx.updateSelectedScopes
                      }, null, 8, ["initial-dropdown-choice", "onComparisonSelectedScopes"])
                    ]),
                    _createElementVNode("div", _hoisted_54, [
                      _createElementVNode("button", {
                        id: "submit-button-forecast-filter",
                        class: "button button-primary",
                        style: {"margin-top":"10px"},
                        type: "submit",
                        disabled: !_ctx.isFinishedLoading,
                        onClick: _cache[2] || (_cache[2] = _withModifiers(($event: any) => (_ctx.filterChangeSubmit()), ["prevent"]))
                      }, [
                        _createVNode(_component_SimpleText, { "text-key": "comparison.create.filter-button-submit.name" })
                      ], 8, _hoisted_55)
                    ])
                  ])
                ], 544)
              ]),
              (_ctx.isScopeActive())
                ? (_openBlock(), _createElementBlock("div", _hoisted_56, [
                    _createElementVNode("h3", _hoisted_57, [
                      _createVNode(_component_SimpleText, { "text-key": 'comparison.create.graph-section.title1' }, null, 8, ["text-key"])
                    ]),
                    _createVNode(_component_ComparisonChartScope, {
                      mode: _ctx.mode,
                      ref: "comparisonChartScopeRef",
                      onMounted: _ctx.updateChart
                    }, null, 8, ["mode", "onMounted"])
                  ]))
                : _createCommentVNode("", true),
              (_ctx.isCategoryActive())
                ? (_openBlock(), _createElementBlock("div", _hoisted_58, [
                    _createElementVNode("h3", _hoisted_59, [
                      _createVNode(_component_SimpleText, { "text-key": 'comparison.create.graph-section.title2' }, null, 8, ["text-key"])
                    ]),
                    _createVNode(_component_ComparisonChartMainCategory, {
                      mode: _ctx.mode,
                      ref: "comparisonChartMainCategoryRef",
                      onMounted: _ctx.updateChart
                    }, null, 8, ["mode", "onMounted"])
                  ]))
                : _createCommentVNode("", true),
              (_ctx.isSubCategoryActive())
                ? (_openBlock(), _createElementBlock("div", _hoisted_60, [
                    _createElementVNode("h3", _hoisted_61, [
                      _createVNode(_component_SimpleText, { "text-key": 'comparison.create.graph-section.title2' }, null, 8, ["text-key"])
                    ]),
                    _createVNode(_component_ComparisonChartIndividualGroups, {
                      mode: _ctx.mode,
                      ref: "comparisonChartIndividualGroupsRef",
                      onMounted: _ctx.updateChart
                    }, null, 8, ["mode", "onMounted"])
                  ]))
                : _createCommentVNode("", true)
            ]),
            _createElementVNode("div", _hoisted_62, [
              (_ctx.isScopeActive())
                ? (_openBlock(), _createElementBlock("h3", _hoisted_63, [
                    _createVNode(_component_SimpleText, { "text-key": "comparison.distribution-scope" })
                  ]))
                : _createCommentVNode("", true),
              (_ctx.isCategoryActive())
                ? (_openBlock(), _createElementBlock("h3", _hoisted_64, [
                    _createVNode(_component_SimpleText, { "text-key": "comparison.distribution-maincategory" })
                  ]))
                : _createCommentVNode("", true),
              (_ctx.isSubCategoryActive())
                ? (_openBlock(), _createElementBlock("h3", _hoisted_65, [
                    _createVNode(_component_SimpleText, { "text-key": "comparison.distribution-category" })
                  ]))
                : _createCommentVNode("", true),
              (_ctx.comparison.calculations)
                ? (_openBlock(), _createElementBlock("div", _hoisted_66, [
                    _createElementVNode("table", _hoisted_67, [
                      _createElementVNode("tbody", null, [
                        _createElementVNode("tr", null, [
                          _createElementVNode("th", _hoisted_68, _toDisplayString(_ctx.tableHeader), 1),
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.comparison.calculations, (item) => {
                            return (_openBlock(), _createElementBlock("th", {
                              key: item.calculation?.id,
                              "data-cy-name": item.calculation?.calculationPurpose.name,
                              class: "text-dark dynamic-width",
                              scope: "col"
                            }, _toDisplayString(item.calculation?.calculationPurpose.name), 9, _hoisted_69))
                          }), 128))
                        ]),
                        (_ctx.isScope1Active(true))
                          ? (_openBlock(), _createElementBlock("tr", _hoisted_70, [
                              _createElementVNode("th", _hoisted_71, [
                                _createVNode(_component_SimpleText, { "text-key": "shared.scope1" })
                              ]),
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.comparison.calculations, (item) => {
                                return (_openBlock(), _createElementBlock("td", {
                                  key: item.calculation?.id,
                                  "data-cy-name": item.calculation?.calculationPurpose.name,
                                  class: "text-dark dynamic-width align-text-right"
                                }, _toDisplayString(_ctx.doPrettify(_ctx.getEmissionValue(item, "SCOPE", "SCOPE_1"), 2)), 9, _hoisted_72))
                              }), 128))
                            ]))
                          : _createCommentVNode("", true),
                        (_ctx.isScope2Active(true))
                          ? (_openBlock(), _createElementBlock("tr", _hoisted_73, [
                              _createElementVNode("th", _hoisted_74, [
                                _createVNode(_component_SimpleText, { "text-key": "shared.scope2" })
                              ]),
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.comparison.calculations, (item) => {
                                return (_openBlock(), _createElementBlock("td", {
                                  key: item.calculation?.id,
                                  "data-cy-name": item.calculation?.calculationPurpose.name,
                                  class: "text-dark dynamic-width align-text-right"
                                }, _toDisplayString(_ctx.doPrettify(_ctx.getEmissionValue(item, "SCOPE", "SCOPE_2"), 2)), 9, _hoisted_75))
                              }), 128))
                            ]))
                          : _createCommentVNode("", true),
                        (_ctx.isScope3Active(true))
                          ? (_openBlock(), _createElementBlock("tr", _hoisted_76, [
                              _createElementVNode("th", _hoisted_77, [
                                _createVNode(_component_SimpleText, { "text-key": "shared.scope3" })
                              ]),
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.comparison.calculations, (item) => {
                                return (_openBlock(), _createElementBlock("td", {
                                  key: item.calculation?.id,
                                  "data-cy-name": item.calculation?.calculationPurpose.name,
                                  class: "text-dark dynamic-width align-text-right"
                                }, _toDisplayString(_ctx.doPrettify(_ctx.getEmissionValue(item, "SCOPE", "SCOPE_3"), 2)), 9, _hoisted_78))
                              }), 128))
                            ]))
                          : _createCommentVNode("", true),
                        (_ctx.isCategoryActive())
                          ? (_openBlock(), _createElementBlock("tr", _hoisted_79, [
                              _createElementVNode("th", _hoisted_80, [
                                _createVNode(_component_SimpleText, { "text-key": "theme.text.category.energy" })
                              ]),
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.comparison.calculations, (item) => {
                                return (_openBlock(), _createElementBlock("td", {
                                  key: item.calculation?.id,
                                  "data-cy-name": item.calculation?.calculationPurpose.name,
                                  class: "text-dark dynamic-width align-text-right"
                                }, _toDisplayString(_ctx.doPrettify(_ctx.getEmissionValue(item, "G", "G_1"), 2)), 9, _hoisted_81))
                              }), 128))
                            ]))
                          : _createCommentVNode("", true),
                        (_ctx.isCategoryActive())
                          ? (_openBlock(), _createElementBlock("tr", _hoisted_82, [
                              _createElementVNode("th", _hoisted_83, [
                                _createVNode(_component_SimpleText, { "text-key": "theme.text.category.purchase2" })
                              ]),
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.comparison.calculations, (item) => {
                                return (_openBlock(), _createElementBlock("td", {
                                  key: item.calculation?.id,
                                  "data-cy-name": item.calculation?.calculationPurpose.name,
                                  class: "text-dark dynamic-width align-text-right"
                                }, _toDisplayString(_ctx.doPrettify(_ctx.getEmissionValue(item, "G", "G_2"), 2)), 9, _hoisted_84))
                              }), 128))
                            ]))
                          : _createCommentVNode("", true),
                        (_ctx.isCategoryActive())
                          ? (_openBlock(), _createElementBlock("tr", _hoisted_85, [
                              _createElementVNode("th", _hoisted_86, [
                                _createVNode(_component_SimpleText, { "text-key": "theme.text.category.transport" })
                              ]),
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.comparison.calculations, (item) => {
                                return (_openBlock(), _createElementBlock("td", {
                                  key: item.calculation?.id,
                                  "data-cy-name": item.calculation?.calculationPurpose.name,
                                  class: "text-dark dynamic-width align-text-right"
                                }, _toDisplayString(_ctx.doPrettify(_ctx.getEmissionValue(item, "G", "G_3"), 2)), 9, _hoisted_87))
                              }), 128))
                            ]))
                          : _createCommentVNode("", true),
                        (_ctx.isCategoryActive())
                          ? (_openBlock(), _createElementBlock("tr", _hoisted_88, [
                              _createElementVNode("th", _hoisted_89, [
                                _createVNode(_component_SimpleText, { "text-key": "theme.text.category.waste" })
                              ]),
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.comparison.calculations, (item) => {
                                return (_openBlock(), _createElementBlock("td", {
                                  key: item.calculation?.id,
                                  "data-cy-name": item.calculation?.calculationPurpose.name,
                                  class: "text-dark dynamic-width align-text-right"
                                }, _toDisplayString(_ctx.doPrettify(_ctx.getEmissionValue(item, "G", "G_4"), 2)), 9, _hoisted_90))
                              }), 128))
                            ]))
                          : _createCommentVNode("", true),
                        (_ctx.isCategoryActive())
                          ? (_openBlock(), _createElementBlock("tr", _hoisted_91, [
                              _createElementVNode("th", _hoisted_92, [
                                _createVNode(_component_SimpleText, { "text-key": "theme.text.category.soldproducts" })
                              ]),
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.comparison.calculations, (item) => {
                                return (_openBlock(), _createElementBlock("td", {
                                  key: item.calculation?.id,
                                  "data-cy-name": item.calculation?.calculationPurpose.name,
                                  class: "text-dark dynamic-width align-text-right"
                                }, _toDisplayString(_ctx.doPrettify(_ctx.getEmissionValue(item, "G", "G_5"), 2)), 9, _hoisted_93))
                              }), 128))
                            ]))
                          : _createCommentVNode("", true),
                        (_ctx.isSubCategoryActive())
                          ? (_openBlock(true), _createElementBlock(_Fragment, { key: 8 }, _renderList(_ctx.getMergedGroupsByGroup(_ctx.selectedComparisonCriteria), (mergedGroup) => {
                              return (_openBlock(), _createElementBlock("tr", { key: mergedGroup }, [
                                _createElementVNode("th", _hoisted_94, [
                                  _createVNode(_component_SimpleText, { "text-key": mergedGroup }, null, 8, ["text-key"])
                                ]),
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.comparison.calculations, (item) => {
                                  return (_openBlock(), _createElementBlock("td", {
                                    key: item.calculation?.id,
                                    "data-cy-name": item.calculation?.calculationPurpose.name,
                                    class: "text-dark dynamic-width align-text-right"
                                  }, _toDisplayString(_ctx.doPrettify(_ctx.getEmissionValueMergedGroup(item, mergedGroup, _ctx.selectedComparisonScopeCriterias), 2)), 9, _hoisted_95))
                                }), 128))
                              ]))
                            }), 128))
                          : _createCommentVNode("", true),
                        _createElementVNode("tr", _hoisted_96, [
                          _createElementVNode("th", _hoisted_97, [
                            _createVNode(_component_SimpleText, { "text-key": "sharedContent.total" })
                          ]),
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.comparison.calculations, (item) => {
                            return (_openBlock(), _createElementBlock("td", {
                              key: item.calculation?.id,
                              "data-cy-name": item.calculation?.calculationPurpose.name,
                              class: "text-dark dynamic-width align-text-right"
                            }, _toDisplayString(_ctx.doPrettify(_ctx.getEmissionValue(item, "SCOPE", "SCOPE_TOTAL"), 2)), 9, _hoisted_98))
                          }), 128))
                        ]),
                        (_ctx.isScopeOutsideActive(true))
                          ? (_openBlock(), _createElementBlock("tr", _hoisted_99, [
                              _createElementVNode("th", _hoisted_100, [
                                _createVNode(_component_SimpleText, { "text-key": "sharedContent.outside-scope" })
                              ]),
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.comparison.calculations, (item) => {
                                return (_openBlock(), _createElementBlock("td", {
                                  key: item.calculation?.id,
                                  "data-cy-name": item.calculation?.calculationPurpose.name,
                                  class: "text-dark dynamic-width align-text-right"
                                }, _toDisplayString(_ctx.doPrettify(_ctx.getEmissionValue(item, "SCOPE", "OUTSIDE_SCOPE"), 2)), 9, _hoisted_101))
                              }), 128))
                            ]))
                          : _createCommentVNode("", true)
                      ])
                    ])
                  ]))
                : _createCommentVNode("", true)
            ]),
            _createElementVNode("div", _hoisted_102, [
              _createElementVNode("label", _hoisted_103, [
                _createVNode(_component_SimpleText, { "text-key": "comparison.create.comment-field.label" })
              ]),
              _createElementVNode("form", {
                onSubmit: _cache[7] || (_cache[7] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.submitComment && _ctx.submitComment(...args)), ["prevent"]))
              }, [
                _createElementVNode("div", null, [
                  _withDirectives(_createElementVNode("textarea", {
                    id: "input-area",
                    "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.comment) = $event)),
                    "aria-labelledby": "comparison-comment-field-label",
                    class: "form-input",
                    maxlength: "255",
                    name: "input-area",
                    rows: "5",
                    style: {"max-width":"555px"}
                  }, "\n      ", 512), [
                    [_vModelText, _ctx.comment]
                  ])
                ]),
                _createElementVNode("button", _hoisted_104, [
                  _createVNode(_component_SimpleText, { "text-key": "comparison.create.save-button.title" })
                ])
              ], 32)
            ]),
            _createElementVNode("a", _hoisted_105, [
              _hoisted_106,
              _createVNode(_component_SimpleText, { "text-key": "comparison.create.back-button.title" })
            ])
          ])
        ]))
      : _createCommentVNode("", true)
  ], 64))
}